import React, { useState } from 'react';
import { Form, Input } from 'antd-mobile';
import { Button } from 'antd-mobile';
import FailModal from 'utility/FailModal';
// import TermsModal from 'utility/TermsModal';
import VerifyCodeComponent from 'utility/VerifyCodeComponent';
import { WebviewHttpHandler } from 'shared/webviewHttpHandler';
import { CryptoHandler } from 'shared/cryptoHandler';
import { useNavigate } from 'react-router-dom';
import secureStorage from 'shared/secureStorage';

const Sales = () => {
  let navigate = useNavigate();
  const httpHandler = new WebviewHttpHandler(true);
  const cryptoHandler = new CryptoHandler();

  const [form] = Form.useForm();
  const identity = Form.useWatch('account', form);
  const phone = Form.useWatch('phone', form);

  const [loading, setLoading] = useState(false);
  // const [isCheckedTerms, setIsCheckedTerms] = useState(false);
  const [isVisibleFail, setIsVisibleFail] = useState(false);
  const [failMessage, setFailMessage] = useState('');

  const onFinish = (values) => {
    setLoading(true);

    const lineUserId = secureStorage.getItem('lineUserId');
    const name = secureStorage.getItem('displayName');
    const profileImageUrl = secureStorage.getItem('pictureUrl');
    const encryptedName = cryptoHandler.encrypt(name);
    const encryptedPhone = cryptoHandler.encrypt(values.phone);

    httpHandler
      .post(`/account/binding/staff`, {
        line: lineUserId,
        name: encryptedName,
        profile_image_url: profileImageUrl,
        account: values.account,
        phone: encryptedPhone,
        code: values.code,
      })
      .then((response) => {
        if (response.success) {
          navigate('/m/Bind/SalesSuccess');
        } else {
          console.log(response);
          setFailMessage(response.message);
          setIsVisibleFail(true);
        }
      })
      .catch((error) => {
        console.log(error);
        window.antdNotify('失敗', '系統錯誤', 'fail');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="main-container">
      <div className="form-container">
        <div className="text-align-center subheading font-bold pd-6">
          【業代】會員綁定
        </div>
        <Form
          className="form-a"
          layout="vertical"
          form={form}
          onFinish={onFinish}>
          <Form.Item
            label="員工編號"
            name="account"
            rules={[
              { required: true, message: '請輸入員工編號' },
              { pattern: /^\d{5}$/, message: '必須為5碼數字' },
            ]}>
            <Input
              className="large-input"
              placeholder="ex：80123"
              type="tel"
              clearable
            />
            {/* ----- 輸入格式錯誤input ----- */}
            {/* <Input
              className="error-input"
              clearable
            />
            <div className="text-body red">格式錯誤，請注意大小寫及字數</div> */}
          </Form.Item>
          <Form.Item
            name="phone"
            label="手機號碼"
            rules={[
              { required: true, message: '請輸入手機號碼' },
              { pattern: /^\d{10}$/, message: '必須為10碼數字' },
            ]}
            extra={
              <VerifyCodeComponent
                apiData={{
                  identity: identity,
                  phone: phone,
                  category: 3,
                }}
              />
            }>
            <Input
              className="large-input"
              placeholder="ex：0987654321"
              type="tel"
              clearable
            />
          </Form.Item>
          <Form.Item
            name="code"
            label="驗證碼"
            rules={[
              { required: true, message: '請輸入驗證碼' },
              { pattern: /^\d{6}$/, message: '必須為6碼數字' },
            ]}>
            <Input
              className="large-input"
              placeholder="6碼數字"
              type="tel"
              clearable
            />
          </Form.Item>
          {/* <Form.Item>
            <TermsModal
              isChecked={isCheckedTerms}
              setIsChecked={setIsCheckedTerms}></TermsModal>
          </Form.Item> */}
          <Form.Item>
            <Button
              block
              className="primary-button"
              type="submit"
              // disabled={!isCheckedTerms}
              loading={loading}>
              立即綁定
            </Button>
            {/* ----- 綁定失敗Modal ----- */}
            <FailModal
              isVisible={isVisibleFail}
              setIsVisible={setIsVisibleFail}
              message={failMessage}></FailModal>
            {/* -----未填寫完畢者button為disacled無法點擊 ----- */}
            {/* <Button block disabled className="disable-button">立即綁定</Button> */}
          </Form.Item>
          <div className="tips-container text-sm font-normal">
            若您沒收到手機驗證碼怎麼辦？
            <ol>
              <li>
                檢查您的手機信號：確保您的手機有穩定的信號，有時信號不佳可能會延遲接收驗證碼。
              </li>
              <li>
                重新發送驗證碼：如果長時間未收到，請嘗試重新請求發送新的驗證碼。
              </li>
              <li>
                聯繫客服支持：如果以上步驟都無法解決問題，請聯繫應用或服務的客服尋求幫助。
              </li>
            </ol>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Sales;
